module.exports = __webpack_public_path__ + "img/just-ok.dcae19a9.svg";